import { CanActivate, CanActivateChild, CanLoad, Router, ActivatedRouteSnapshot, RouterStateSnapshot, Route } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from '../auth.service';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {

    constructor(private router: Router, private authService: AuthService) {
    }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (route.data.role.toLowerCase() === this.authService.userRole.toLowerCase()) {
            return true;
        }
        this.router.navigate(['/']);
        return false;
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (route.data.role.toLowerCase() ===  this.authService.userRole.toLowerCase()) {
            return true;
        }
        // if (route.data.role[1].toLowerCase() ===  this.authService.userRole.toLowerCase()) {
        //    return true;
        // }
        this.router.navigate(['/']);
        return false;
    }

    canLoad(route: Route): boolean {
        const url = `/${route.path}`;
        return this.checkLogin(url, route);
    }

    checkLogin(url: string, route: Route): boolean {
        if (route.data.role.toLowerCase() === this.authService.userRole.toLowerCase()) {
            return true;
        }
        // if (route.data.role[1].toLowerCase() === this.authService.userRole.toLowerCase()) {
        //     return true;
        // }
        this.router.navigate(['/']);
        return false;
    }
}
